import { useCallback, useRef, useState } from 'react'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import {
  type TicketListOnData,
  type TicketListPresetId,
} from 'modules/ticketing/components/TicketList/TicketList'
import { useTicketingPolicies } from 'modules/ticketing/hooks/useTicketingPolicies'
import { TicketListPageContent } from 'modules/ticketing/pages/TicketListPage'

const INBOX_TICKETING_PRESETS = [
  'assigned_to_me',
  'requested_by_me',
] as const satisfies ReadonlyArray<TicketListPresetId>

const InboxTicketListPage = () => {
  const { loading, canViewTicketing } = useTicketingPolicies()
  const [defaultPreset, setDefaultPreset] = useState<TicketListPresetId>('assigned_to_me')
  const evaluatedInitialDataRef = useRef(false)

  const handleData = useCallback<TicketListOnData>(
    (nodes) => {
      if (evaluatedInitialDataRef.current) return

      evaluatedInitialDataRef.current = true

      if (defaultPreset === 'assigned_to_me' && nodes.length === 0) {
        setDefaultPreset('requested_by_me')
      }
    },
    [defaultPreset]
  )

  if (loading) return <Loading />
  if (!canViewTicketing) return <NotFound />

  return (
    <TicketListPageContent
      availablePresets={INBOX_TICKETING_PRESETS}
      defaultPreset={defaultPreset}
      onData={handleData}
      fetchPolicy="network-only"
    />
  )
}

export default InboxTicketListPage
